// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"UserLayout_layoutWrapper__P8PdZ","mainContent":"UserLayout_mainContent__+6yn0","contentWrapper":"UserLayout_contentWrapper__qf7RD"};